import { z } from "zod";
import { EMPTY } from "../str.js";
import { transformJson } from "./transformers.js";
const zEmptyString = z.literal(EMPTY);
function zFromJson(schema) {
    return z.string().transform(transformJson(schema));
}
export { zEmptyString, zFromJson };

//# sourceMappingURL=schemas.js.map